
import Accounting from "@/views/Accounting/Accounting.vue";
import Accounts from "@/views/Accounting/Accounts.vue";
import EntryDaily from "@/views/Accounting/EntryDairy.vue";
import DiaryBook from "@/views/Accounting/DiaryBook.vue";
import PaymentMethods from "@/views/Accounting/PaymentMethods.vue";
import CategoryAccounts from "@/views/Accounting/CategoryAccounts.vue";
import ViewEntryDiaryBook from "@/components/Accounting/ViewEntryDiaryBook.vue";
import BoxesToAccounting from "@/views/Accounting/BoxesToAccounting.vue";
import ViewEntryPayroll from "@/views/Accounting/ViewEntryPayroll.vue";
import ViewEntryDetail from "@/views/Accounting/ViewEntryDetail.vue";
import PayrollAccounting from "@/views/Accounting/PayrollAccounting.vue";
import RevaluatePeriods from "@/views/Accounting/RevaluatePeriods.vue"
import ViewRevaluation from "@/views/Accounting/ViewRevaluation.vue"
import WithholdingsSuppliers from "@/views/Accounting/WithholdingsSuppliers.vue"
import RevaluatePeriodsException from "@/views/Accounting/RevaluatePeriodsException.vue"
import ReportStatus from "@/views/Accounting/Reports/Status.vue"
import TrialBalance from "@/views/Accounting/Reports/TrialBalance.vue"
import DocumentsRecivedDgii from "@/views/Accounting/DocumentsRecivedDgii.vue"
import Dgii from "@/views/Accounting/Reports/Dgii.vue"
import AffiliatesBalance from "@/views/Accounting/Reports/AffiliatesBalance.vue"
import ViewDocumentRecived from "@/views/Accounting/ViewDocumentRecived.vue"
import CommercialApprovals from "@/views/Accounting/CommercialApprovals.vue"

const accounting = {
  path: "/accounting",
  name: "Accounting",
  component: Accounting,
  meta: {
    libre: true
  },
  children: [

    {
      path: "accounts",
      name: "Accounts",
      component: Accounts,
      meta: {
        code: "CON-01" // Cambiado de IVENTORY: true a un código específico
      },
    },

    {
      path: "withholdings_suppliers",
      name: "WithholdingsSuppliers",
      component: WithholdingsSuppliers,
      meta: {
        code: "CON-06" // RETENCIONES DEL SUPLIDOR (coincide con el menú); antes CON-18 (RETENCIONES)
      },
    },
    {
      path: "diary_book",
      name: "DiaryBook",
      component: DiaryBook,
      meta: {
        code: "CON-03"
      },
    },
    {
      path: "documents_recived_dgii",
      name: "DocumentsRecivedDgii",
      component: DocumentsRecivedDgii,

    },
    {
      path: "commercial_approvals",
      name: "CommercialApprovals",
      component: CommercialApprovals,
      meta: {
        code: "CON-121"
      },
    },
    {
      path: "revaluate_period_exceptions",
      name: "RevaluatePeriodsException",
      component: RevaluatePeriodsException,
      meta: {
        code: "CON-131" // VER EXEPCION DE REVALUACION: controla el acceso a la pantalla
      },
    },
    {
      path: "report",
      name: "Report",
      component: Accounting,
      meta: {
        libre: true,
      },
      children: [
        {
          path: "report_status",
          name: "ReportStatus",
          component: ReportStatus,
          meta: {
            code: "CON-04" // Cambiado de IVENTORY: true a un código específico
          },
        },
        {
          path: "report_trial_balance",
          name: "TrialBalance",
          component: TrialBalance,
          meta: {
            code: "CON-05"
          }
        },
        {
          path: "dgii",
          name: "Dgii",
          component: Dgii,

        },
        {
          path: "affiliates_balance",
          name: "AffiliatesBalance",
          component: AffiliatesBalance,

        }
      ]
    },
    {
      path: "revaluate_period",
      name: "RevaluatePeriods",
      component: RevaluatePeriods,

    },

    {
      path: "view_account/:id?",
      name: "ViewEntryDiaryBook",
      component: ViewEntryDiaryBook,
      meta: {
        // Detalle de asiento desde Catálogo/Estados/Balance/Libro Diario.
        code: ["CON-01", "CON-03", "CON-04", "CON-05", "CON-02"]
      },
    },
    {
      path: "view_document_recived/:rnc/:encf",
      name: "ViewDocumentRecived",
      component: ViewDocumentRecived,

    },
    {
      path: "view_revaluation/:id?",
      name: "ViewRevaluation",
      component: ViewRevaluation,
      meta: {
        code: "CON-10" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "view_entry_payroll/:id?",
      name: "ViewEntryPayroll",
      component: ViewEntryPayroll,
      meta: {
        code: "CON-09" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "view_entry_detail/:id?",
      name: "ViewEntryDetail",
      component: ViewEntryDetail,
      meta: {
        // Detalle de asiento: accesible desde Libro Diario, Entrada de Diario, Estados,
        // Balance, Catálogo o Nóminas. Antes exigía solo CON-09 (nóminas) por error.
        code: ["CON-02", "CON-03", "CON-04", "CON-05", "CON-01", "CON-09"]
      },
    },
    {
      path: "PayrollAccounting",
      name: "PayrollAccounting",
      component: PayrollAccounting,
      meta: {
        code: "CON-09" // Cambiado de IVENTORY: true a un código específico
      },
    },

    {
      path: "categories",
      name: "CategoryAccounts",
      component: CategoryAccounts,
      meta: {
        code: "CON-15" // Cambiado de IVENTORY: true a un código específico
      },
    },

    {
      path: "entry_daily",
      name: "EntryDaily",
      component: EntryDaily,
      meta: {
        code: "CON-02" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "payment_methods",
      name: "PaymentMethods",
      component: PaymentMethods,
      meta: {
        code: "CON-16" // Cambiado de IVENTORY: true a un código específico
      },
    },
    {
      path: "BoxesToAccounting",
      name: "BoxesToAccounting",
      component: BoxesToAccounting,
      meta: {
        code: "CON-08" // Cambiado de IVENTORY: true a un código específico
      },
    },
    //   {
    //     path: "Prepaid",
    //     name: "Prepaid",
    //     component: Prepaid,
    //     meta: {
    //       ACCOUNTING: true,
    //     },
    //   },
    // {
    //   path: "view_invoice/:id?",
    //   name: "ViewInvoice",
    //   component: ViewInvoice,
    //   meta: {
    //     SHOP: true,
    //   },
    // },

    // {
    //   path: "download_invoice/:id?",
    //   name: "DownloadInvoice",
    //   component: DownloadInvoice,
    //   meta: {
    //     SHOP: true,
    //   },
    // },
  ],
}
export default accounting

